import { createQueryStore } from '@/core/lib/utils/create-query'
import { ID } from '@/core/types/models/id.model'
import { searchLocation } from '../../providers/client'
import { AirportModel } from '../../types/models/airport.model'

export const useSearchFromLocation = createQueryStore<
  AirportModel[],
  { countryId?: ID; search?: string; controller?: AbortController }
>(
  ({ countryId, search, controller }) =>
    searchLocation({ countryId, search, source: 'from' }, { controller }),
  [],
)

export const useSearchToLocation = createQueryStore<
  AirportModel[],
  { countryId?: ID; search?: string; controller?: AbortController }
>(
  ({ countryId, search, controller }) =>
    searchLocation({ countryId, search, source: 'to' }, { controller }),
  [],
)
